import * as React from 'react'
import { cn } from '../../utils/lib/utils'
import PropTypes from 'prop-types'

const textVariants = {
  h1: 'text-4xl font-bold',
  h2: 'text-3xl font-bold',
  h3: 'text-2xl font-bold',
  h4: 'text-xl font-bold',
  h5: 'text-lg font-bold',
  h6: 'text-base font-bold',
  body: 'text-base',
  small: 'text-sm',
  tiny: 'text-xs'
}

const textColors = {
  default: 'text-foreground',
  muted: 'text-muted-foreground',
  primary: 'text-primary',
  secondary: 'text-secondary',
  success: 'text-green-600',
  warning: 'text-yellow-600',
  error: 'text-red-600'
}

export const Text = React.forwardRef(({ 
  children,
  variant = 'body',
  color = 'default',
  className,
  ...props 
}, ref) => {
  return (
    <span
      ref={ref}
      className={cn(
        textVariants[variant],
        textColors[color],
        className
      )}
      {...props}
    >
      {children}
    </span>
  )
})

Text.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(Object.keys(textVariants)),
  color: PropTypes.oneOf(Object.keys(textColors)),
  className: PropTypes.string
}

Text.displayName = 'Text'
